import React, { useEffect, useState } from 'react';
import httpCommon from '../../../http-common';
import { MenuItem, Select } from '@mui/material';
import { edit_schedule_api } from '../../Output/utils/edit_schedule_service';
import getErrorMessage, { logout_if_403 } from '../../../util';

const RealTimeAnalystDropdown = ({
    id,
    field,
    row,
    rowNode,
    colDef,
    cellMode,
    hasFocus,
    tabIndex,
    value,
    formattedValue,
    isEditable,
    api
}) => {
    const [analysts, setAnalysts] = useState([]);
    const get_skilled_analysts = async () => {
        try {
            const { test_name } = row;
            const response = await httpCommon.get(`/v1/qc/get_analyst_for_test?test_id=${encodeURIComponent(test_name)}`);
            const result = response.data;
            // console.log(result);
            setAnalysts(result.skilled_analysts);
            return result;
        } catch (error) {
            logout_if_403(error);
            console.error(getErrorMessage(error));
        }
    };
    const [selected_analyst, set_selected_analyst] = useState(row.analyst_id);
    useEffect(() => {
        get_skilled_analysts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div>
            {
                !isEditable ? selected_analyst :
                    (analysts && analysts.length > 0 ?
                        <Select
                            id={`${id}`}
                            value={selected_analyst}
                            label="Analyst ID"
                            size='small'
                            onChange={
                                async (e) => {
                                    try {
                                        set_selected_analyst(e.target.value);
                                        const { _id } = row;
                                        console.log(row);
                                        const response = await edit_schedule_api({ _id, analyst_id: e.target.value });
                                        if (response.status) {
                                            api.updateRows([{ id, analyst_id: e.target.value }]);
                                        }
                                        else {
                                            alert(response.message);
                                        }
                                        row.analyst_id = e.target.value;
                                    } catch (error) {
                                        logout_if_403(error);
                                        console.error(error);
                                    }
                                }
                            }
                        >
                            {
                                analysts.map((analyst) => (
                                    <MenuItem key={`${id}-${analyst}`} value={analyst}>
                                        {analyst}
                                    </MenuItem>
                                ))
                            }
                        </Select>
                        :
                        selected_analyst)
            }
        </div>
    );
};

export default RealTimeAnalystDropdown;